module.exports = __webpack_public_path__ + "static/metro-logo-cabc7bf030558ed90dcfba5c876dae4e.png";